import { useLocation, useNavigate } from "react-router-dom";
import HeaderMenu from "../sidebar/headermenu";
import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { UploadProfilePic } from "../../apis/user/upload_profile_pic";

export default function UpdateProfilePic() {
    const navigate = useNavigate();
    const location = useLocation();
    const [pic, setPic] = useState('');
    const [picName, setPicName] = useState('');
    const [uploadStatus, setUploadStatus] = useState(API_STATUS);
    const [status, setStatus] = useState(false);
    const [userData, setUserData] = useState("");


    useEffect(() => {
        if (pic !== '') {
            setPicName(URL.createObjectURL(pic));
        }
    }, [pic]);

    useEffect(() => {
        const loginData = sessionStorage.getItem('LOGIN_DATA');
        const udata = JSON.parse(loginData);
        setUserData(udata);
        setPicName(udata['userPic']);
    }, []);

    const uploadPic = () => {
        let formData = new FormData();
        formData.append('profile_pic', pic);
        UploadProfilePic(formData, setUploadStatus);
    }

    useEffect(() => {
        if (!uploadStatus.isLoader && !uploadStatus.isError && uploadStatus.data != null) {
            let res = uploadStatus.data;
            if (res) {
                setStatus(true);
                navigate('/');
            }
        }
    }, [uploadStatus]);


    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
            <div className="max-w-2xl mx-auto">
                <div className="page__heading py-6 mt-6">
                    <a href="/">
                        <ion-icon name="chevron-back-outline"></ion-icon> Back
                    </a>
                    <h1> Upload profile pic</h1>
                </div>

                <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

                    <div className="relative flex md:gap-8 gap-4 items-center md:p-10 p-6">


                        <div className="relative md:w-20 md:h-20 w-12 h-12 shrink-0">

                            <label for="file" className="cursor-pointer">
                                {
                                    picName !== "" &&
                                    <img id="img" src={picName} className="object-cover w-full h-full rounded-full" alt="" />
                                }
                            </label>

                            <label for="file" className="md:p-1 p-0.5 rounded-full bg-slate-600 md:border-4 border-white absolute -bottom-2 -right-2 cursor-pointer dark:border-slate-700">

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="md:w-4 md:h-4 w-3 h-3 fill-white">
                                    <path d="M12 9a3.75 3.75 0 100 7.5A3.75 3.75 0 0012 9z"></path>
                                    <path fill-rule="evenodd" d="M9.344 3.071a49.52 49.52 0 015.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 01-3 3h-15a3 3 0 01-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 001.11-.71l.822-1.315a2.942 2.942 0 012.332-1.39zM6.75 12.75a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm12-1.5a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd"></path>
                                </svg>

                                <input id="file" type="file" accept="image/*" onChange={(e) => {
                                    setPic(e.target.files[0]);
                                }} className="hidden" />

                            </label>

                        </div>

                        <div className="flex-1">
                            <h3 className="md:text-xl text-base font-semibold text-black dark:text-white"> {userData['firstName']} {userData['u_lastName']} </h3>
                            <p className="text-sm text-blue-600 mt-1 font-normal">{userData['username']}</p>
                        </div>
                        {
                            uploadStatus.isLoader &&
                            <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                <span class="sr-only">Loading...</span>
                            </div>

                        }

                    </div>
                    {
                        picName !== "" && picName !== userData['userPic'] && !status &&
                        <div className="flex md:gap-8 gap-4 items-center md:p-10 p-6">
                            <div className="spinner-border text-primary" role="status">
                            </div>
                            <button type="button" onClick={() => { setPicName(userData['userPic']) }} class="button bg-primary-soft text-primary">Cancel</button>
                            <button type="button" onClick={uploadPic} class="button text-white bg-primary">Upload</button>
                        </div>
                    }
                    {
                        status &&
                        <div className="text-green-600 px-6 pb-6">Profile pic upload success</div>
                    }

                    <hr className="border-t border-gray-100 dark:border-slate-700" />

                </div>
            </div>
        </main>
    </div>
}